import script from "./CouponForm.vue?vue&type=script&setup=true&lang=js"
export * from "./CouponForm.vue?vue&type=script&setup=true&lang=js"

import "./CouponForm.vue?vue&type=style&index=0&id=b9c48168&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b9c48168"]])

export default __exports__